import { useGetAllTermsOfUseQuery } from './__generated__/allTerms.generated';

export const useAllTermsOfUse = ({ organisationUuid }: { organisationUuid: string }) => {
	return useGetAllTermsOfUseQuery({ variables: { organisationUuid } });
};
